import React from 'react';
import BaseEChart from './BaseEChart';
import { buildComparisonRatingOption } from './comparisonOptions';
import type { ComparisonRatingBucket } from '@app-types/comparison';

export interface ComparisonRatingChartProps {
  ratings: ComparisonRatingBucket[];
  height?: number;
  className?: string;
}

/**
 * Five-bar rating distribution chart used inside ComparisonCard.
 * Renders through BaseEChart; do not import ReactECharts directly.
 * See kiro_comparison_tasks.md §8, Figma node 3226:19249.
 */
const ComparisonRatingChart: React.FC<ComparisonRatingChartProps> = ({
  ratings,
  height = 127,
  className,
}) => {
  const option = buildComparisonRatingOption(ratings);
  return (
    <BaseEChart
      option={option}
      height={height}
      className={className}
      ariaLabel="コンセンサスレーティング分布"
    />
  );
};

export default ComparisonRatingChart;
